import { Component, ElementRef, OnChanges, Renderer2, ViewChild, AfterViewInit } from '@angular/core';
import { BaseRenderComponent } from 'cms/workspace/workspace-generic-classes/base-render.component';

import { PieceSeparatorSettings } from './models/piece-separator.models';


@Component({
  selector: 'piece-separator-render',
  templateUrl: './piece-separator-render.component.html',
  styleUrls: ['./piece-separator-render.component.scss']
})
export class PieceSeparatorRenderComponent
  extends BaseRenderComponent<PieceSeparatorSettings>
  implements AfterViewInit, OnChanges {

  @ViewChild('separator', { static: false }) private readonly separatorRef?: ElementRef;

  constructor(
    private readonly renderer: Renderer2
  ) {
    super();
  }

  public ngAfterViewInit() {
    this.setupStyles();
  }

  public ngOnChanges(): void {
    this.setupStyles();
  }

  private setupStyles() {
    const height = this.toUnit(this.settings.general?.height ?? '1pt');
    const width = this.toUnit(this.settings.general?.width ?? '100%');
    const bgColor = this.settings.general?.lineColor ?? null;
    this.setSeparatorProperty('height', height);
    this.setSeparatorProperty('width', width);
    this.setSeparatorProperty('background-color', bgColor);
  }

  private setSeparatorProperty(property: string, setting: string | null): void {
    if (isDefined(this.separatorRef)) {
      this.renderer.setStyle(this.separatorRef.nativeElement, property, setting);
    }
  }

  private toUnit(value: string | number, unit = '%'): string {
    return (typeof value === 'number') ? `${value}${unit}` : value;
  }

}
